import { eaptekaApi } from '../../eaptekaApi';

export const eaptekaApiRequestPromocodeDelete =
  eaptekaApi.createDeleteMethod('/cart/promocode', {
    mapResponse: (response) => response.status === 200
  });
